import axios from "axios";
import { domain } from "../Constants";
import AuthServiceMember from "../AuthServiceMember";
import Service from "../Service";

const image = {
  uploadImage(image) {
    return Service.post(`api/image-up`, image);
  },

  uploadImageMember(image) {
    return Service.post(`api/image-up`, image);
  },

  upload(file, onUploadProgress) {
    let param = new FormData();
    param.append("file", file.image);
    param.append("type", file.type);

    return Service.post(`api/image-up`, param, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  },
  uploadImageFb(url, onUploadProgress) {
    return Service.post(
      `api/image-up-facebook`,
      { url: url },
      {
        onUploadProgress,
      }
    );
  },
};

export default image;
